module.exports = __webpack_public_path__ + "static/media/hollow_bar_M1.017d2738.svg";